import {Component, Input, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {AppDialogService} from '../../services/AppDialogService';
import {InputText} from 'primeng/inputtext';
import {Select} from 'primeng/select';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-scale',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    InputText,
    Select
  ],
  template: `
    @if (field.field_type === 'scale') {
      <div class="form-row flex-align-center">
        <label>{{ Yii.t('app', 'Type') }}</label>
        <div class="flex-row gap-8px">
          <p-select
            [(ngModel)]="field.input_type"
            [options]="[{label: 'Standard', value: ''},{label: 'Temperature', value: 'temperature'}]"
            appendTo="body"
          />
          @if (field.input_type === 'temperature') {
            <p-select
              [(ngModel)]="field.temperature_format"
              [options]="[{label: 'F', value: 'F'}, {label: 'C', value: 'C'}]"
              appendTo="body"
            />
          }
        </div>
      </div>
    }
    <div class="form-row flex-align-center">
      <label>{{ Yii.t('app', 'Min value') }}</label>
      <div>
        <input
          pInputText
          type="number"
          [(ngModel)]="field.min_scale_value"
          (change)="checkScaleValues(field.min_scale_value, field.max_scale_value)">
      </div>
    </div>
    <div class="form-row flex-align-center">
      <label>{{ Yii.t('app', 'Max value') }}</label>
      <div>
        <input
          pInputText
          type="number"
          [(ngModel)]="field.max_scale_value"
          (change)="checkScaleValues(field.min_scale_value, field.max_scale_value)">
      </div>
    </div>
  `
})
export class FieldScale implements OnInit {
  ngOnInit(): void {
    if (!this.field.input_type) {
      this.field.input_type = '';
    }
  }

  Yii = Yii;
  @Input() field: any;

  constructor(
    private dialogs: AppDialogService
  ) {
  }

  checkScaleValues(min: any, max: any): void {
    const minVal = parseInt(min, 10);
    const maxVal = parseInt(max, 10);

    if (!isNaN(minVal) && !isNaN(maxVal) && minVal > maxVal) {
      this.field.max_scale_value = min;
      this.field.min_scale_value = max;
      this.dialogs.Alert(
        "Error",
        Yii.t('app', 'The Min is more than Max. Scale Values will be replaced automatically!')
      )
    }

    const fieldValue = this.field.field_value;
    const isFieldValueEmpty = fieldValue === null || fieldValue === undefined || fieldValue.toString().trim() === '';
    const parsedFieldValue = parseInt(fieldValue, 10);

    if (isFieldValueEmpty || !/^\d+$/.test(fieldValue) || parsedFieldValue < minVal || parsedFieldValue > maxVal) {
      this.field.field_value = min;
    }
  }
}
